export const collectionItems = [
  {
    id: "film",
    icon: "ri-film-line",
    title: "电影改编方向",
    summary:
      "把潘金莲故事压缩进一部长片的叙事容量，多以古装、戏曲或文艺路线呈现，强调人物与场景的集中表达。",
    points: ["古装戏曲片", "文艺重构", "古装人物片", "当代翻拍"],
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20illustration%20of%20an%20old%20style%20filming%20lantern%20stage%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20cinematic%20and%20serene%2C%20no%20text%2C%20editorial%20composition&width=800&height=600&seq=pjl-collection-film&orientation=landscape",
    alt: "水墨风格的电影改编方向示意图",
  },
  {
    id: "tv",
    icon: "ri-tv-2-line",
    title: "电视剧版本方向",
    summary:
      "以长篇剧集容纳《水浒传》《金瓶梅》的人物支线，潘金莲多作为关键配角或单元主角出现，篇幅更长、人物关系更完整。",
    points: ["名著改编剧", "重拍版本", "单元叙事", "年代剧集"],
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20of%20a%20traditional%20courtyard%20house%20at%20dusk%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20quiet%20storytelling%20mood%2C%20no%20text%2C%20editorial%20composition&width=800&height=600&seq=pjl-collection-tv&orientation=landscape",
    alt: "水墨风格的电视剧版本方向示意图",
  },
  {
    id: "series",
    icon: "ri-stack-line",
    title: "系列电影方向",
    summary:
      "同一题材在不同年代被反复拍摄，形成片名相近、主创不同的系列化作品群，适合按年代顺序对照浏览。",
    points: ["同题材多部", "不同演员版本", "制片厂系列", "跨地区翻拍"],
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20of%20stacked%20old%20film%20reels%20and%20scrolls%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20archival%20atmosphere%2C%20no%20text%2C%20editorial%20composition&width=800&height=600&seq=pjl-collection-series&orientation=landscape",
    alt: "水墨风格的系列电影方向示意图",
  },
  {
    id: "stage",
    icon: "ri-mic-line",
    title: "戏曲与舞台方向",
    summary:
      "川剧、京剧、评剧等剧种中都有以潘金莲为主角的剧目，侧重唱腔、身段与对人物的重新评价。",
    points: ["地方剧种", "翻案视角", "经典折子", "当代新编"],
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20of%20a%20traditional%20opera%20stage%20with%20red%20curtain%20and%20lanterns%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20dramatic%20yet%20calm%2C%20no%20text%2C%20editorial%20composition&width=800&height=600&seq=pjl-collection-stage&orientation=landscape",
    alt: "水墨风格的戏曲舞台方向示意图",
  },
  {
    id: "web",
    icon: "ri-smartphone-line",
    title: "网络影像方向",
    summary:
      "近年网络电影与短剧常借用人物名号开展改编，单集篇幅短、节奏快，属于当代衍生的一种形态。",
    points: ["网络电影", "竖屏短剧", "数字发行", "轻量改编"],
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20of%20a%20small%20screen%20glowing%20warmly%20on%20a%20paper%20desk%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20modern%20meets%20classic%2C%20no%20text%2C%20editorial%20composition&width=800&height=600&seq=pjl-collection-web&orientation=landscape",
    alt: "水墨风格的网络影像方向示意图",
  },
  {
    id: "novel",
    icon: "ri-book-2-line",
    title: "文学原著方向",
    summary:
      "《水浒传》与《金瓶梅》是最主要的文本来源，绝大多数影视改编都从这两部作品的段落与人物线取材。",
    points: ["水浒传支线", "金瓶梅人物", "市井生活", "人物小传"],
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20of%20open%20old%20thread%20bound%20books%20and%20brush%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20literary%20quiet%20atmosphere%2C%20no%20text%2C%20editorial%20composition&width=800&height=600&seq=pjl-collection-novel&orientation=landscape",
    alt: "水墨风格的文学原著方向示意图",
  },
];